import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import LandingPage from "./components/LandingPage/LandingPage";
import { useAuth } from "./Context/AuthContext";
import RoleSwitcher from "./components/Demo/RoleSwitcher";
import ResolutionFeedbackModal from "./components/ResolutionFeedbackModal/ResolutionFeedbackModal";

function RootLayout() {
  const { user, isAdmin, isAssistant, roleChecked } = useAuth();
  const navigate = useNavigate();// Get the logged-in user status
 
 
  const location = useLocation();

  // Pages that should NOT have top padding
  const noPaddingPages = ["/complaints-website"];

  const needsPadding = !noPaddingPages.includes(location.pathname);

  return (
    <div>
      {user ? (
        <>
          <NavBar />

          <div
            style={{
              minHeight: "90vh",
              paddingTop: needsPadding ? "70px" : "0px",
            }}
          >
            <Outlet />
          </div>

          
          {roleChecked && !isAdmin && !isAssistant && <ResolutionFeedbackModal />}
        </>
      ) : (
        <LandingPage />
      )}
      <Footer />

      <RoleSwitcher />
    </div>
  );
}

export default RootLayout;